import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import classnames from 'classnames2';
import React from 'react';
import { Divider } from '../../Divider';
import { Icon } from '../../Icon';
import styles from './Wizard.Step.scss';
export var WizardStep = function WizardStep(props) {
  var _classnames, _classnames2, _classnames3, _classnames4;

  var isFirstStep = props.index === 1;
  var isCompleted = props.index < props.activeStepIndex;
  var isActive = props.index === props.activeStepIndex;
  var isLastStep = props.index === props.numberOfSteps;
  var stepNumberTopLineStyles = classnames((_classnames = {}, _defineProperty(_classnames, styles.line, !isFirstStep), _defineProperty(_classnames, styles.lineInvisible, isFirstStep), _defineProperty(_classnames, styles.lineComplete, (isCompleted || isActive) && !isFirstStep), _classnames));
  var stepNumberStyles = classnames((_classnames2 = {}, _defineProperty(_classnames2, styles.stepNumberActive, isActive), _defineProperty(_classnames2, styles.stepNumberInactive, !isActive && !isCompleted), _defineProperty(_classnames2, styles.stepNumberComplete, isCompleted), _classnames2));
  var stepNumberBottomLineStyles = classnames((_classnames3 = {}, _defineProperty(_classnames3, styles.line, !isLastStep), _defineProperty(_classnames3, styles.lineInvisible, isLastStep), _defineProperty(_classnames3, styles.lineComplete, isCompleted && !isLastStep), _classnames3));
  var stepLabelContainerStyles = classnames((_classnames4 = {}, _defineProperty(_classnames4, styles.stepLabelActive, isActive), _defineProperty(_classnames4, styles.stepLabelNotActive, !isActive), _defineProperty(_classnames4, styles.stepLabelContainer, true), _classnames4));
  return React.createElement("li", {
    className: styles.stepContainer,
    role: "listitem",
    "data-test": "".concat(props.dataTest, "-step"),
    onClick: function onClick() {
      props.onClick(props.index);
    }
  }, React.createElement("div", {
    className: styles.stepNumberContainer
  }, React.createElement("div", {
    className: stepNumberTopLineStyles
  }), React.createElement("div", {
    className: stepNumberStyles
  }, isCompleted && React.createElement(Icon, {
    icon: "form-check"
  }), !isCompleted && props.index), React.createElement("div", {
    className: stepNumberBottomLineStyles
  })), React.createElement("div", {
    className: stepLabelContainerStyles
  }, React.createElement(Divider.ListItem, null), React.createElement("div", {
    className: styles.stepLabel
  }, props.label), isLastStep ? React.createElement(Divider.ListItem, null) : React.createElement("div", {
    className: styles.stepDividerInvisible
  })));
};